import React, { useState, useEffect, Suspense } from "react";
import {
  AppBar,
  Toolbar,
  MenuList,
  Drawer,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../styles";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";

const MenuListComponent = React.lazy(() => import("./MenuList"));

const useStyles = makeStyles({
  title: {
    color: theme.palette.primary.contrastText,
    alignContent: "left",
    justifyContent: "left",
    textAlign: "left",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      marginTop: "0.15em",
    },
    marginTop: "0.75em",
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    position: "fixed",
  },
  horizontalMenu: {
    display: "flex",
    position: "absolute",
    right: 5,
    top: 3,
  },
  divL: {
    display: "flex",
    flexDirection: "row-reverse",
  },
  drawerContainer: {
    padding: "20px 30px",
  },
  drawerIcon: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    padding: "1px",
    position: "absolute",
    right: "0",
  },
  displayNone: {
    display: "none",
  },
  displayBlock: {
    display: "block",
  },
});

export default function Header() {
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView, drawerOpen } = state;
  const classes = useStyles();
  const trigger = useScrollTrigger();

  //mobile/small display header code
  const displayMobile = () => {
    return (
      <Toolbar>
        <Button
          className={classes.drawerIcon}
          onClick={() => setState({ ...state, drawerOpen: true })}
        >
          &#9776;
        </Button>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: () => setState({ ...state, drawerOpen: false }),
          }}
        >
          <div className={classes.drawerContainer}>
            <MenuList color={theme.palette.secondary.contrastText}>
              <Suspense fallback={<CircularProgress />}>
                <MenuListComponent />
              </Suspense>
            </MenuList>
          </div>
        </Drawer>
        <a className={classes.title} href="/">
          <Typography variant="h6" className={classes.title}>
            HOST
          </Typography>
        </a>
      </Toolbar>
    );
  };

  //desktop/large display header code
  const displayDesktop = () => {
    return (
      <Toolbar className={trigger ? classes.displayNone : classes.displayBlock}>
        <Typography variant="h6" className={classes.title}>
          <a className={classes.title} href="/">
            {" "}
            HOST - Humanizing Online Services Toolkit{" "}
          </a>
        </Typography>
        <div className={classes.divL}>
          <MenuList className={classes.horizontalMenu}>
            <Suspense fallback={<CircularProgress />}>
              <MenuListComponent />
            </Suspense>
          </MenuList>
        </div>
      </Toolbar>
    );
  };

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 960
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  return (
    <AppBar className={classes.appBar} position="static">
      {mobileView ? displayMobile() : displayDesktop()}
    </AppBar>
  );
}
